<template>
    <div class="container">
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <h2>Hello {{user.name}}</h2>
                <p>Welcome to your messages</p>
            </div>
        </div>
        <div class="row justify-content-center u-mt2 has-margins">
            <div class="col-12 col-xs-12 col-md-6">
                <div class="row">
                    <div class="col-6 big-link" :class="newMessages.audio ? '-new' : ''">
                        <span class="new-messages" v-if="newMessages.audio">{{newMessages.audio}}</span>
                        <router-link class="bigLink -calls" to="/calls" :class="newMessages.audio ? '-new' : ''">
                            Your Calls
                        </router-link>
                    </div>
                    <div class="col-6 big-link" :class="newMessages.text ? '-new' : ''">
                        <span class="new-messages" v-if="newMessages.text">{{newMessages.text}}</span>
                        <router-link class="bigLink -messages" to="/messages" :class="newMessages.text ? '-new' : ''">
                            Your Messages
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 big-link" :class="newMessages.video ? '-new' : ''">
                        <span class="new-messages" v-if="newMessages.video">{{newMessages.video}}</span>
                        <router-link class="bigLink -videos" to="/videos" :class="newMessages.video ? '-new' : ''">
                            Your Videos
                        </router-link>
                    </div>
                    <div class="col-6 big-link" :class="newMessages.image ? '-new' : ''">
                        <span class="new-messages" v-if="newMessages.image">{{newMessages.image}}</span>
                        <router-link class="bigLink -gallery" to="/gallery" :class="newMessages.image ? '-new' : ''">
                            Your Gallery
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 big-link">
                        <router-link class="bigLink -send" to="/send">
                            Send a Message
                        </router-link>
                    </div>
                    <div class="col-6 big-link">
                        <router-link class="bigLink -recipients" to="/recipients" v-if="user.is_creator" >
                            Your Recipients
                        </router-link>
                        <router-link class="bigLink -recipients" to="/upgrade" v-else>
                            Upgrade
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Logo from '@/components/Logo.vue'
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import _ from 'lodash';
export default {
    name: 'home',
    data : function () {
        return {
            newMessages : {
                audio : false,
                video : false,
                text  : false,
                image : false
            }
        }
    },
    components: {
        Logo
    },
    mounted : function () {
        this.checkForNew();
    },
    mixins : [auth, userdetails],
    methods : {
        checkForNew : function () {
            let self = this;
            this.axios.get(this.api + 'messages/new')
                .then(response => {
                    var results = response.data;
                    _.each(results, function (value, key) {
                        self.newMessages[key] = _.size(value);
                    });
                })
                .catch(error => {
                    console.error('Error getting new messages', error);
                });
        }
    }
}
</script>
